export enum ChatContextEnum {
  SURVEY_BUILDER = 'surveyBuilder',
  TESTING = 'testing'
}
